import { useState } from 'react';

/**
 * Custom hook to update community view during search.
 * @returns {Object} - selectCommunity: A setter for community selection, newCommunity: A signal that toggles when the community changes, selectedCommunity: The currently selected community.
 */
export default function useSelectCommunity() {
    const [selectedCommunity, setSelectedCommunity] = useState(null);
    const [newCommunity, setNewCommunity] = useState(1); // This signal toggles between 1 and -1 to indicate a change in community selection.

    function selectCommunity(communityId) {
        console.log('community selected:', communityId);
        setNewCommunity((prev) => prev * (-1));
        setSelectedCommunity(communityId);
    }

    return {
        selectCommunity,
        newCommunity, 
        selectedCommunity,
    };
}